export class ResourceTypeFilters {
    '_in';
    'notIn';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<ResourceType>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<ResourceType>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ResourceTypeFilters.attributeTypeMap;
    }
    constructor() {
    }
}
